"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * WPSEO.AI
 *
 * @package       WPSEOAI
 * @author        WPSEO.AI Ltd
 * License:       MIT
 */
const plugins_1 = require("@wordpress/plugins");
const edit_post_1 = require("@wordpress/edit-post");
// import { PanelBody, TextControl, Button } from '@wordpress/components';
const components_1 = require("@wordpress/components");
const react_1 = require("react");
// import { registerBlockType } from '@wordpress/blocks';
const data_1 = require("@wordpress/data");
// import { useEntityProp } from '@wordpress/core-data';
// import {InspectorControls, useBlockProps} from '@wordpress/block-editor';
const i18n_1 = require("@wordpress/i18n");
const blocks_1 = require("@wordpress/blocks");
// import {ToolsPanel} from "@wordpress/components/build-types/tools-panel";
const api_fetch_1 = __importDefault(require("@wordpress/api-fetch"));
const WPSEOAISidebar = ({ isOpen, setIsOpen }) => {
    var _a;
    let interval;
    const [data, setData] = (0, react_1.useState)({
        stale: false,
        locales: null,
        defaultLocale: null,
        summary: null,
        submissionState: 0,
        auditId: 0,
        postId: 0,
        revisionId: 0,
        showRetrieve: false,
    });
    const updateData = (newData) => setData(prev => (Object.assign(Object.assign({}, prev), newData)));
    const getSubmissionState = () => {
        var _a;
        return (_a = data.submissionState) !== null && _a !== void 0 ? _a : 0;
    };
    const handleError = (error) => {
        // createErrorNotice(error?.message, {
        //     // type: 'snackbar',
        // });
        if (error.name === 'AbortError')
            console.log('Request has been aborted');
        console.error(error === null || error === void 0 ? void 0 : error.message);
        alert(error === null || error === void 0 ? void 0 : error.message);
    };
    const resetSubmissionState = (newData) => {
        // Stop interval
        clearInterval(interval);
        // Submission state to: none
        updateData(Object.assign(Object.assign({}, newData), { submissionState: 0 }));
    };
    const retrieveData = () => {
        console.log(`Attempting submission retrieval`);
        const controller = typeof AbortController === 'undefined' ? undefined : new AbortController();
        // Gather context of this post
        (0, api_fetch_1.default)({
            path: `/wpseoai/v1/retrieve?post=${data.postId}`,
            signal: controller === null || controller === void 0 ? void 0 : controller.signal,
        })
            .then((data) => {
            const res = data;
            console.log(res);
            // if (res.hasOwnProperty('auditId'))
            updateData({
                stale: res.code === 200,
                submissionState: res.code === 200 ? 0 : 2,
                showRetrieve: res.code !== 200,
            });
        })
            .catch((error) => {
            handleError(error);
            updateData({ submissionState: 0 });
        });
    };
    const handleClick = (e) => {
        e.preventDefault();
        const locale = e.currentTarget.getAttribute('data-locale');
        if (!locale)
            return;
        // Submission state to: sent
        updateData({ submissionState: 1 });
        const controller = typeof AbortController === 'undefined' ? undefined : new AbortController();
        // Initiate post data submission
        (0, api_fetch_1.default)({
            path: `/wpseoai/v1/optimize?locale=${locale}&post=${data.postId}`,
            signal: controller === null || controller === void 0 ? void 0 : controller.signal,
        })
            .then((data) => {
            let nextData = {};
            const res = data;
            // Post ID for the audit record
            if (res === null || res === void 0 ? void 0 : res.auditId)
                nextData.auditId = res.auditId;
            // Submission state to: processing
            nextData.submissionState = 2;
            updateData(nextData);
            console.log(`Submission sent`);
        })
            .catch((error) => {
            handleError(error);
            // Submission state to: none
            updateData({ submissionState: 0 });
        });
    };
    (0, react_1.useEffect)(() => {
        // Monitor state change of a submission
        if (!data.showRetrieve && data.submissionState === 2) {
            const highTime = 15000;
            const lowTime = 2500;
            let lastTime = Date.now();
            let i = 0;
            let j = 0;
            const intervalCallback = () => {
                let intervalTime = highTime - (j * lowTime);
                if (intervalTime < lowTime)
                    intervalTime = lowTime;
                let nextTime = lastTime + intervalTime;
                const currentTime = Date.now();
                if (currentTime >= nextTime) {
                    // console.log(`currentTime: ${currentTime}`);
                    // console.log(`intervalTime: ${intervalTime}`);
                    // console.log(`lastTime: ${lastTime}`);
                    // console.log(`nextTime: ${nextTime}`);
                    // console.log(`i: ${i}`);
                    // console.log(`j: ${j}`);
                    // Invalid audit ID
                    if (!data.auditId) {
                        console.log(`Invalid audit ID, unable to track progress of submission`);
                        return resetSubmissionState();
                    }
                    const controller = typeof AbortController === 'undefined' ? undefined : new AbortController();
                    // Request state of audit record
                    (0, api_fetch_1.default)({
                        path: `/wpseoai/v1/audit?post=${data.auditId}&limit=1`,
                        signal: controller === null || controller === void 0 ? void 0 : controller.signal,
                    })
                        .then((data) => {
                        const res = data;
                        // Audit post has received response
                        if ((res === null || res === void 0 ? void 0 : res.state) === '1') {
                            // Suggest a refresh
                            // TODO: Refactor indicator for submission received
                            resetSubmissionState({ stale: true });
                            console.log(`Response received`);
                        }
                    })
                        .catch((error) => {
                        handleError(error);
                        resetSubmissionState();
                    });
                    lastTime = currentTime;
                    j++;
                }
                i++;
                // Prevent endless polling
                if (i > 12) {
                    resetSubmissionState();
                    console.log(`Post-back not received; interval cleared`);
                    retrieveData();
                }
            };
            interval = setInterval(intervalCallback, lowTime);
        }
    }, [data.submissionState]);
    (0, react_1.useEffect)(() => {
        // Get current post ID
        const postId = (0, data_1.select)('core/editor').getCurrentPostId();
        updateData({ postId });
        const revisionId = (0, data_1.select)('core/editor').getCurrentPostLastRevisionId();
        updateData({ revisionId });
        const controller = typeof AbortController === 'undefined' ? undefined : new AbortController();
        // Gather context of this post
        (0, api_fetch_1.default)({
            path: `/wpseoai/v1/context?post=${postId}`,
            signal: controller === null || controller === void 0 ? void 0 : controller.signal,
        })
            .then((data) => {
            let nextData = {};
            const res = data;
            if (res.hasOwnProperty('defaultLocale'))
                nextData.defaultLocale = res.defaultLocale;
            if (res.hasOwnProperty('locales'))
                nextData.locales = res.locales;
            if (res.hasOwnProperty('summary'))
                nextData.summary = res.summary;
            updateData(nextData);
        })
            .catch((error) => {
            handleError(error);
        });
    }, []);
    const statusColor = data.stale
        ? 'green'
        : (data.submissionState === 2
            ? 'blue'
            : (data.submissionState === 1
                ? 'blue'
                : 'grey'));
    return ((0, jsx_runtime_1.jsxs)(edit_post_1.PluginSidebar, { name: "wpseoai-sidebar", title: "WPSEO.AI (Beta)", icon: "share-alt", children: [(0, jsx_runtime_1.jsxs)(components_1.PanelBody, { title: (0, i18n_1.__)(`Help`, `ai-seo-wp`), initialOpen: false, children: [(0, jsx_runtime_1.jsx)("p", { children: (0, i18n_1.__)(`The WPSEO.AI service is currently in beta phase. More features are in development.`, `ai-seo-wp`) }), (0, jsx_runtime_1.jsx)("p", { children: (0, i18n_1.__)(`Please note, using the buttons and features on this sidebar, will deduct small chunks of credits, based on the content provided, from your subscription balance.`, `ai-seo-wp`) }), (0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { href: `/wp-admin/revision.php?revision=${data.revisionId}&gutenberg=true`, children: "View revisions" }) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { href: `/wp-admin/admin.php?page=wpseoai_dashboard`, children: "View audit logs" }) }), (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { href: `https://wpseo.ai/faq.html`, target: `_blank`, children: "Frequently asked questions" }) })] })] }), (0, jsx_runtime_1.jsx)(components_1.PanelBody, { title: "Summary of changes", className: !data.summary ? 'hidden' : '', children: (0, jsx_runtime_1.jsx)("p", { children: (_a = data.summary) !== null && _a !== void 0 ? _a : (0, jsx_runtime_1.jsx)("i", { children: "N/A" }) }) }), (0, jsx_runtime_1.jsx)(components_1.PanelBody, { title: "Status", children: (0, jsx_runtime_1.jsxs)("p", { className: `wpseoai-status ${statusColor}`, children: [(0, jsx_runtime_1.jsx)("div", { "aria-hidden": `true` }), (0, jsx_runtime_1.jsx)("span", { children: data.stale ? ((0, jsx_runtime_1.jsx)("a", { href: ``, children: (0, i18n_1.__)(`Reload page`, `ai-seo-wp`) })) : (data.submissionState === 2 ? ((0, jsx_runtime_1.jsx)("i", { children: (0, i18n_1.__)(`Processing`, `ai-seo-wp`) })) : (data.submissionState === 1 ? ((0, jsx_runtime_1.jsx)("i", { children: (0, i18n_1.__)(`Sending`, `ai-seo-wp`) })) : ((0, jsx_runtime_1.jsx)("i", { children: (0, i18n_1.__)(`Inactive`, `ai-seo-wp`) })))) })] }) }), (0, jsx_runtime_1.jsxs)(components_1.PanelBody, { title: (0, i18n_1.__)(`Tools`, `ai-seo-wp`), children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(components_1.Button, { "data-locale": data.defaultLocale, variant: "primary", onClick: handleClick, isBusy: getSubmissionState() > 0, "aria-disabled": getSubmissionState() > 0, disabled: getSubmissionState() > 0, children: (0, i18n_1.__)(`Finesse (All)`, `ai-seo-wp`) }) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(components_1.Button, { variant: "secondary", className: !data.showRetrieve ? `hidden` : '', onClick: () => retrieveData(), "aria-disabled": getSubmissionState() === 0, disabled: getSubmissionState() === 0, children: (0, i18n_1.__)('Retrieve', `ai-seo-wp`) }) })] }), !data.locales ? null :
                (0, jsx_runtime_1.jsxs)(components_1.PanelBody, { title: (0, i18n_1.__)(`Translate (WPML)`, `ai-seo-wp`), children: [(0, jsx_runtime_1.jsx)("p", { children: "Choose the language to translate this content into. Activate more languages, for more options below." }), (0, jsx_runtime_1.jsx)("p", { children: data.locales && Object.entries(data.locales).map(([code, locale]) => {
                                if (locale.code === data.defaultLocale)
                                    return;
                                // console.log(locale);
                                return (0, jsx_runtime_1.jsx)(components_1.Button, { className: `wpseoai-translate`, "data-locale": code, variant: "secondary", onClick: handleClick, isBusy: getSubmissionState() > 0, "aria-disabled": getSubmissionState() > 0, children: locale.display_name });
                            }) })] })] }));
};
// Wrap the component using the withState higher-order component to manage the sidebar state
const WPSEOAISidebarWithState = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(WPSEOAISidebar, { isOpen: isOpen, setIsOpen: setIsOpen }), (0, jsx_runtime_1.jsx)(edit_post_1.PluginSidebarMoreMenuItem, { target: "wpseoai-sidebar", children: "WPSEO.AI (Beta)" })] }));
};
// Register the plugin and add the sidebar to the Gutenberg editor
(0, plugins_1.registerPlugin)('custom-sidebar', {
    render: WPSEOAISidebarWithState,
});
// Register the collection.
(0, blocks_1.registerBlockCollection)('wpseoai', {
    title: (0, i18n_1.__)('WPSEO.AI (Beta)', `ai-seo-wp`),
});
